module.exports = __webpack_public_path__ + "img/02.e72812a8.png";